import { fetchImage } from '@/api/image.api';
import Events from '@/services/Events';
import { t } from '@/translations/i18n';
import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { IProduct } from '@/typescript/interfaces/IProduct';

async function initProductImages(product: IProduct) {
    const fields = await Promise.all(
        product.configuration.fields.map(async (field) => {
            if (!('uuid' in field)) {
                return field;
            }

            const imgField = field as IImageField;
            if (!imgField.uuid) {
                return field;
            }
            try {
                const imgBlob = await fetchImage(imgField.uuid);
                imgField.url = URL.createObjectURL(imgBlob);
            } catch (e) {
                Events.emit('call-toaster', {
                    title: t('error_title'),
                    body: t('image_load_error', { name: imgField.filename || '' }),
                    type: 'error',
                });
            }

            return imgField;
        }),
    );

    return {
        ...product,
        configuration: {
            ...product.configuration,
            fields,
        },
    };
}

export { initProductImages };
